var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomes(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 160,
    viewBox: "0 0 448 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.88 -24.7012H62.527V160.124H175.88V-24.7012Z",
    fill: "#FFC85A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.248 160.442H127.27V46.5729L155.29 30.2148L182.248 46.5729V160.442Z",
    fill: "#FCE5B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.824 56.1329L112.305 46.9979L155.184 20.9736L195.409 46.573L189.678 55.4956L155.078 33.5077L117.824 56.1329Z",
    fill: "#A5B1C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.26 48.8037L155.184 23.3105L194.454 48.2726L189.784 55.4956L155.078 33.5078L117.718 56.1329L113.26 48.8037Z",
    fill: "#D9DFE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.786 65.4805H140.325V160.442H170.786V65.4805Z",
    fill: "#EDB554"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.366 59.7451H133.532V65.7997H177.366V59.7451Z",
    fill: "#D9DFE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.434 102.658H144.146V156.088H166.434V102.658Z",
    fill: "#A97C50"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.496 157.149H143.084V101.596H167.496V157.149ZM145.207 155.025H165.373V103.72H145.207V155.025Z",
    fill: "#F9FBFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M166.328 80.458H144.252V102.764H166.328V80.458Z",
    fill: "#98CBFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.328 103.826H144.252C143.615 103.826 143.19 103.402 143.19 102.764V80.4577C143.19 79.8204 143.615 79.3955 144.252 79.3955H166.328C166.965 79.3955 167.389 79.8204 167.389 80.4577V102.764C167.389 103.402 166.859 103.826 166.328 103.826ZM145.313 101.702H165.267V81.5199H145.313V101.702Z",
    fill: "#F9FBFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.719 108.5H148.391V129.744H162.719V108.5Z",
    fill: "#8E6643"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M153.486 134.312H148.391V150.777H153.486V134.312Z",
    fill: "#8E6643"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M162.932 134.312H157.837V150.777H162.932V134.312Z",
    fill: "#8E6643"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.875 154.601H142.023V160.549H168.875V154.601Z",
    fill: "#E8EBEF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.351 80.9893H154.229V102.871H156.351V80.9893Z",
    fill: "#F9FBFC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M166.859 91.1865H144.252V93.311H166.859V91.1865Z",
    fill: "#F9FBFC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.557 -6.64355H78.2351V33.7206H104.557V-6.64355Z",
    fill: "#98CBFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.557 34.7825H78.2351C77.5983 34.7825 77.1738 34.3576 77.1738 33.7203V-6.64384C77.1738 -7.28117 77.5983 -7.70605 78.2351 -7.70605H104.557C105.194 -7.70605 105.618 -7.28117 105.618 -6.64384V33.7203C105.618 34.3576 105.088 34.7825 104.557 34.7825ZM79.2965 32.6581H103.495V-5.58163H79.2965V32.6581Z",
    fill: "#F9FBFC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.529 32.4453H75.3695V37.6502H107.529V32.4453Z",
    fill: "#F9FBFC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5635 -6.43164H90.4408V34.2511H92.5635V-6.43164Z",
    fill: "#F9FBFC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3463 -6.43164H84.2849V34.2511H85.3463V-6.43164Z",
    fill: "#F9FBFC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.396 13.2197H78.9781V14.2819H91.396V13.2197Z",
    fill: "#F9FBFC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5072 -6.43164H97.4458V34.2511H98.5072V-6.43164Z",
    fill: "#F9FBFC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M104.557 13.2197H92.139V14.2819H104.557V13.2197Z",
    fill: "#F9FBFC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.557 83.9639H78.2351V124.328H104.557V83.9639Z",
    fill: "#98CBFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M104.557 125.39H78.2351C77.5983 125.39 77.1738 124.965 77.1738 124.328V83.9636C77.1738 83.3263 77.5983 82.9014 78.2351 82.9014H104.557C105.194 82.9014 105.618 83.3263 105.618 83.9636V124.328C105.618 124.859 105.088 125.39 104.557 125.39ZM79.2965 123.266H103.495V85.0258H79.2965V123.266Z",
    fill: "#F9FBFC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M107.529 79.6084H75.3695V84.8133H107.529V79.6084Z",
    fill: "#F9FBFC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M107.529 123.053H75.3695V128.258H107.529V123.053Z",
    fill: "#F9FBFC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5635 84.1758H90.4408V124.859H92.5635V84.1758Z",
    fill: "#F9FBFC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3463 84.1758H84.2849V124.859H85.3463V84.1758Z",
    fill: "#F9FBFC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.396 103.827H78.9781V104.889H91.396V103.827Z",
    fill: "#F9FBFC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5072 84.1758H97.4458V124.859H98.5072V84.1758Z",
    fill: "#F9FBFC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M104.557 103.827H92.139V104.889H104.557V103.827Z",
    fill: "#F9FBFC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M177.366 63.0381H133.532V65.7998H177.366V63.0381Z",
    fill: "#A5B1C2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M120.583 136.437L118.885 137.393V139.729H116.656V137.393L114.852 136.437L113.154 137.393V139.729H110.925V137.393L109.121 136.437L107.423 137.393V139.729H105.194V137.393L103.389 136.437L101.691 137.393V139.729H99.4624V137.393L97.6581 136.437L95.9599 137.393V139.729H93.7311V137.393L91.9267 136.437L90.2286 137.393V139.729H87.6813V137.393L85.877 136.437L84.1788 137.393V139.729H81.95V137.393L80.1457 136.437L78.4475 137.393V139.729H76.0064V137.393L74.202 136.437L72.5039 137.393V139.729H70.275V137.393L68.4707 136.437L66.7725 137.393V160.336H70.275V157.999H72.5039V160.336H76.0064V157.999H78.2352V160.336H81.7377V157.999H83.9665V160.336H87.6813V157.999H89.9102V160.336H93.4127V157.999H95.6415V160.336H99.144V157.999H101.479V160.336H104.981V157.999H107.21V160.336H110.713V157.999H112.942V160.336H116.444V157.999H118.673V160.336H122.175V137.286L120.583 136.437ZM70.275 156.194V141.535H72.5039V156.194H70.275ZM76.0064 156.194V141.535H78.2352V156.194H76.0064ZM81.8438 156.194V141.535H84.0727V156.194H81.8438ZM87.6813 156.194V141.535H89.9102V156.194H87.6813ZM93.4127 156.194V141.535H95.6415V156.194H93.4127ZM99.2501 156.194V141.535H101.479V156.194H99.2501ZM104.981 156.194V141.535H107.21V156.194H104.981ZM110.819 156.194V141.535H113.048V156.194H110.819ZM116.55 156.194V141.535H118.779V156.194H116.55Z",
    fill: "#F9FBFC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0478 118.591H42.6797V160.336H49.0478V118.591Z",
    fill: "#A97C50"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1473 116.087C54.5513 109.548 50.3931 103.109 43.8598 101.704C37.3264 100.299 30.8919 104.46 29.488 110.999C28.084 117.537 32.2422 123.977 38.7755 125.382C45.3089 126.787 51.7434 122.626 53.1473 116.087Z",
    fill: "#C3EA86"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6563 133.708C49.3814 128.979 49.3814 121.312 44.6563 116.583C39.9312 111.854 32.2703 111.854 27.5452 116.583C22.8201 121.312 22.8201 128.979 27.5452 133.708C32.2703 138.437 39.9312 138.437 44.6563 133.708Z",
    fill: "#C3EA86"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0595 111.899C50.7418 111.899 56.159 106.478 56.159 99.7899C56.159 93.1022 50.7418 87.6807 44.0595 87.6807C37.3771 87.6807 31.96 93.1022 31.96 99.7899C31.96 106.478 37.3771 111.899 44.0595 111.899Z",
    fill: "#C3EA86"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4987 135.926C59.0263 129.415 54.9911 122.898 48.4858 121.369C41.9805 119.84 35.4686 123.879 33.941 130.389C32.4134 136.9 36.4486 143.417 42.9539 144.946C49.4592 146.475 55.9711 142.436 57.4987 135.926Z",
    fill: "#C3EA86"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4607 136.968C63.3119 136.968 70.4873 129.786 70.4873 120.928C70.4873 112.07 63.3119 104.889 54.4607 104.889C45.6095 104.889 38.4342 112.07 38.4342 120.928C38.4342 129.786 45.6095 136.968 54.4607 136.968Z",
    fill: "#C3EA86"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7907 127.089C56.4731 127.089 61.8902 121.667 61.8902 114.979C61.8902 108.292 56.4731 102.87 49.7907 102.87C43.1084 102.87 37.6912 108.292 37.6912 114.979C37.6912 121.667 43.1084 127.089 49.7907 127.089Z",
    fill: "#C3EA86"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M394.85 137.282C403.381 137.282 410.297 130.159 410.297 121.372C410.297 112.585 403.381 105.462 394.85 105.462C386.319 105.462 379.403 112.585 379.403 121.372C379.403 130.159 386.319 137.282 394.85 137.282Z",
    fill: "#C3EA86"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M388.217 152.537C396.748 152.537 403.664 145.414 403.664 136.627C403.664 127.84 396.748 120.717 388.217 120.717C379.686 120.717 372.77 127.84 372.77 136.627C372.77 145.414 379.686 152.537 388.217 152.537Z",
    fill: "#C3EA86"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M398.485 119.126C407.016 119.126 413.932 112.003 413.932 103.216C413.932 94.4288 407.016 87.3057 398.485 87.3057C389.953 87.3057 383.038 94.4288 383.038 103.216C383.038 112.003 389.953 119.126 398.485 119.126Z",
    fill: "#C3EA86"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M426.279 146.045C434.299 137.785 434.299 124.393 426.279 116.133C418.26 107.873 405.257 107.873 397.238 116.133C389.218 124.393 389.218 137.785 397.238 146.045C405.257 154.305 418.26 154.305 426.279 146.045Z",
    fill: "#C3EA86"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M405.754 139.154C414.285 139.154 421.201 132.031 421.201 123.244C421.201 114.457 414.285 107.334 405.754 107.334C397.223 107.334 390.307 114.457 390.307 123.244C390.307 132.031 397.223 139.154 405.754 139.154Z",
    fill: "#C3EA86"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M234.129 143.649C244.225 143.649 252.409 135.465 252.409 125.369C252.409 115.274 244.225 107.09 234.129 107.09C224.034 107.09 215.85 115.274 215.85 125.369C215.85 135.465 224.034 143.649 234.129 143.649Z",
    fill: "#C3EA86"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M226.28 161.175C236.375 161.175 244.559 152.991 244.559 142.896C244.559 132.8 236.375 124.616 226.28 124.616C216.184 124.616 208 132.8 208 142.896C208 152.991 216.184 161.175 226.28 161.175Z",
    fill: "#C3EA86"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M244.882 122.789C254.977 122.789 263.161 114.605 263.161 104.509C263.161 94.4135 254.977 86.2295 244.882 86.2295C234.786 86.2295 226.602 94.4135 226.602 104.509C226.602 114.605 234.786 122.789 244.882 122.789Z",
    fill: "#C3EA86"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M409.329 45.585H296.426V160.746H409.329V45.585Z",
    fill: "#FFC85A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M394.383 18.918H261.265V59.133H419.329L394.383 18.918Z",
    fill: "#4B6584"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M297.394 161.176H224.275V46.0151L261.587 19.5635L297.394 46.0151V161.176Z",
    fill: "#FFE197"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M219.006 57.9503L215.028 52.8966L261.695 15.7998L304.49 51.1761L300.404 56.1224L261.587 24.0794L219.006 57.9503Z",
    fill: "#7A8DA4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M406.103 117.305H302.877C302.017 117.305 301.48 116.337 302.017 115.585L315.888 95.3696C316.103 95.047 316.426 94.9395 316.748 94.9395H393.845C394.168 94.9395 394.598 95.1545 394.813 95.4771L407.071 115.692C407.501 116.445 406.963 117.305 406.103 117.305Z",
    fill: "#4B6584"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M284.92 161.391V114.617H237.071V161.391",
    fill: "#A97C50"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M286.533 161.391H283.308V116.23H238.684V161.391H235.458V114.617C235.458 113.757 236.211 113.004 237.071 113.004H284.92C285.781 113.004 286.533 113.757 286.533 114.617V161.391Z",
    fill: "#F9FBFC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M333.738 68.166H316.963V88.3811H333.738V68.166Z",
    fill: "#98CBFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M333.63 89.9936H316.856C315.996 89.9936 315.243 89.2409 315.243 88.3807V68.1656C315.243 67.3054 315.996 66.5527 316.856 66.5527H333.63C334.49 66.5527 335.243 67.3054 335.243 68.1656V88.3807C335.243 89.3484 334.598 89.9936 333.63 89.9936ZM318.576 86.7678H332.125V69.7785H318.576V86.7678Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M315.996 161.499V124.08H334.06V161.499",
    fill: "#A97C50"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M335.673 161.499H332.447V125.693H317.609V161.499H314.383V124.08C314.383 123.219 315.136 122.467 315.996 122.467H334.06C334.92 122.467 335.673 123.219 335.673 124.08V161.499Z",
    fill: "#F9FBFC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M274.705 64.9393C274.275 57.1974 267.931 51.0684 260.082 51.0684C252.232 51.0684 245.888 57.1974 245.458 64.9393V91.9286H274.813L274.705 64.9393Z",
    fill: "#98CBFF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M274.705 93.542H245.458C244.598 93.542 243.845 92.7893 243.845 91.9291V64.9398C243.845 64.7248 243.845 64.6172 243.953 64.5097C244.598 56.1226 251.695 49.5635 260.189 49.5635C268.684 49.5635 275.781 56.1226 276.426 64.5097C276.426 64.6172 276.533 64.8323 276.533 64.9398V91.9291C276.318 92.7893 275.566 93.542 274.705 93.542ZM247.071 90.3162H273.092V65.2624C273.092 65.1549 273.092 65.0473 273.092 65.0473C272.662 58.1656 266.963 52.6818 260.082 52.6818C253.2 52.6818 247.501 58.0581 247.071 65.0473C247.071 65.1549 247.071 65.2624 247.071 65.3699V90.3162Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M261.695 50.9609H258.469V91.2835H261.695V50.9609Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M274.49 63.542H245.673V66.7678H274.49V63.542Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M330.727 128.596H319.329V144.187H330.727V128.596Z",
    fill: "#98CBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M244.275 116.229H240.834V161.283H244.275V116.229Z",
    fill: "#D8AA84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M250.404 116.229H246.963V161.283H250.404V116.229Z",
    fill: "#D8AA84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M256.641 116.229H253.2V161.283H256.641V116.229Z",
    fill: "#D8AA84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M262.77 116.229H259.329V161.283H262.77V116.229Z",
    fill: "#D8AA84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M268.899 116.229H265.458V161.283H268.899V116.229Z",
    fill: "#D8AA84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M275.028 116.229H271.587V161.283H275.028V116.229Z",
    fill: "#D8AA84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M281.265 116.229H277.824V161.283H281.265V116.229Z",
    fill: "#D8AA84"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M402.877 123.327H354.275V152.897H402.877V123.327Z",
    fill: "#98CBFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M402.877 154.51H354.275C353.415 154.51 352.662 153.757 352.662 152.897V123.327C352.662 122.467 353.415 121.714 354.275 121.714H402.877C403.738 121.714 404.49 122.467 404.49 123.327V152.897C404.49 153.864 403.738 154.51 402.877 154.51ZM355.888 151.284H401.264V124.94H355.888V151.284Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M389.006 123.327H385.781V152.359H389.006V123.327Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M372.555 123.327H369.329V152.359H372.555V123.327Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M406.748 117.09H302.34V120.316H406.748V117.09Z",
    fill: "#364A5E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M419.329 58.918H297.394V62.1438H419.329V58.918Z",
    fill: "#364A5E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M384.383 68.166H362.017V88.3811H384.383V68.166Z",
    fill: "#98CBFF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M384.383 89.9936H362.017C361.157 89.9936 360.404 89.2409 360.404 88.3807V68.1656C360.404 67.3054 361.157 66.5527 362.017 66.5527H384.383C385.243 66.5527 385.996 67.3054 385.996 68.1656V88.3807C385.996 89.3484 385.243 89.9936 384.383 89.9936ZM363.63 86.7678H382.77V69.7785H363.63V86.7678Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M374.813 68.3809H371.587V88.1658H374.813V68.3809Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M333.845 74.5098H317.071V77.7356H333.845V74.5098Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M395.351 113.542H334.383C333.523 113.542 332.77 112.79 332.77 111.929C332.77 111.069 333.523 110.316 334.383 110.316H395.351C396.211 110.316 396.963 111.069 396.963 111.929C396.963 112.79 396.211 113.542 395.351 113.542Z",
    fill: "#364A5E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M362.017 107.09H314.92C314.06 107.09 313.308 106.337 313.308 105.477C313.308 104.617 314.06 103.864 314.92 103.864H362.017C362.877 103.864 363.63 104.617 363.63 105.477C363.63 106.337 362.877 107.09 362.017 107.09Z",
    fill: "#364A5E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M369.867 100.961H331.695C330.834 100.961 330.082 100.208 330.082 99.3483C330.082 98.488 330.834 97.7354 331.695 97.7354H369.867C370.727 97.7354 371.48 98.488 371.48 99.3483C371.48 100.208 370.727 100.961 369.867 100.961Z",
    fill: "#364A5E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M392.662 100.746H375.243C374.383 100.746 373.63 99.9936 373.63 99.1334C373.63 98.2732 374.383 97.5205 375.243 97.5205H392.662C393.523 97.5205 394.275 98.2732 394.275 99.1334C394.275 100.101 393.523 100.746 392.662 100.746Z",
    fill: "#364A5E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M395.458 107.09H369.867C369.006 107.09 368.254 106.337 368.254 105.477C368.254 104.617 369.006 103.864 369.867 103.864H395.458C396.318 103.864 397.071 104.617 397.071 105.477C397.071 106.337 396.426 107.09 395.458 107.09Z",
    fill: "#364A5E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M326.856 113.112H310.942C310.082 113.112 309.329 112.359 309.329 111.499C309.329 110.638 310.082 109.886 310.942 109.886H326.856C327.716 109.886 328.469 110.638 328.469 111.499C328.469 112.466 327.716 113.112 326.856 113.112Z",
    fill: "#364A5E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M368.039 53.6496H313.738C312.877 53.6496 312.125 52.8969 312.125 52.0367C312.125 51.1765 312.877 50.4238 313.738 50.4238H368.039C368.899 50.4238 369.652 51.1765 369.652 52.0367C369.652 52.8969 369.006 53.6496 368.039 53.6496Z",
    fill: "#364A5E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M408.254 53.4338H374.383C373.523 53.4338 372.77 52.6811 372.77 51.8209C372.77 50.9607 373.523 50.208 374.383 50.208H408.254C409.114 50.208 409.867 50.9607 409.867 51.8209C409.867 52.7886 409.114 53.4338 408.254 53.4338Z",
    fill: "#364A5E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M377.609 45.9074H306.748C305.888 45.9074 305.135 45.1548 305.135 44.2945C305.135 43.4343 305.888 42.6816 306.748 42.6816H377.501C378.361 42.6816 379.114 43.4343 379.114 44.2945C379.222 45.2623 378.469 45.9074 377.609 45.9074Z",
    fill: "#364A5E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M404.813 45.5852H384.168C383.308 45.5852 382.555 44.8325 382.555 43.9723C382.555 43.1121 383.308 42.3594 384.168 42.3594H404.813C405.673 42.3594 406.426 43.1121 406.426 43.9723C406.426 44.8325 405.673 45.5852 404.813 45.5852Z",
    fill: "#364A5E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M400.512 37.843H309.114C308.254 37.843 307.501 37.0903 307.501 36.2301C307.501 35.3699 308.254 34.6172 309.114 34.6172H400.512C401.372 34.6172 402.125 35.3699 402.125 36.2301C402.125 37.1978 401.372 37.843 400.512 37.843Z",
    fill: "#364A5E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M342.985 31.0686H286.211C285.351 31.0686 284.598 30.3159 284.598 29.4557C284.598 28.5955 285.351 27.8428 286.211 27.8428H342.985C343.845 27.8428 344.598 28.5955 344.598 29.4557C344.598 30.3159 343.845 31.0686 342.985 31.0686Z",
    fill: "#364A5E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M369.652 31.0686H349.544C348.684 31.0686 347.931 30.3159 347.931 29.4557C347.931 28.5955 348.684 27.8428 349.544 27.8428H369.652C370.512 27.8428 371.264 28.5955 371.264 29.4557C371.264 30.3159 370.619 31.0686 369.652 31.0686Z",
    fill: "#364A5E"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M395.888 31.2834H375.996C375.136 31.2834 374.383 30.5307 374.383 29.6705C374.383 28.8103 375.136 28.0576 375.996 28.0576H395.888C396.748 28.0576 397.501 28.8103 397.501 29.6705C397.501 30.5307 396.748 31.2834 395.888 31.2834Z",
    fill: "#364A5E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M389.544 24.8323H279.544C278.684 24.8323 277.931 24.0796 277.931 23.2194C277.931 22.3591 278.684 21.6064 279.544 21.6064H389.544C390.404 21.6064 391.157 22.3591 391.157 23.2194C391.157 24.0796 390.512 24.8323 389.544 24.8323Z",
    fill: "#364A5E"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M293.308 74.7241H283.093C281.265 74.7241 279.867 73.3262 279.867 71.4983C279.867 69.6703 281.265 68.2725 283.093 68.2725H293.308C295.136 68.2725 296.533 69.6703 296.533 71.4983C296.533 73.2187 295.028 74.7241 293.308 74.7241Z",
    fill: "#FCD57E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M262.877 44.2944H252.985C251.157 44.2944 249.759 42.8965 249.759 41.0686C249.759 39.2406 251.157 37.8428 252.985 37.8428H262.877C264.705 37.8428 266.103 39.2406 266.103 41.0686C266.103 42.8965 264.705 44.2944 262.877 44.2944Z",
    fill: "#FCD57E"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M239.006 110.316H229.114C227.286 110.316 225.888 108.918 225.888 107.09C225.888 105.262 227.286 103.864 229.114 103.864H239.006C240.834 103.864 242.232 105.262 242.232 107.09C242.232 108.81 240.834 110.316 239.006 110.316Z",
    fill: "#FCD57E"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M288.146 83.5415H282.447C280.619 83.5415 279.221 82.1436 279.221 80.3157C279.221 78.4877 280.619 77.0898 282.447 77.0898H288.146C289.974 77.0898 291.372 78.4877 291.372 80.3157C291.372 82.1436 289.974 83.5415 288.146 83.5415Z",
    fill: "#FCD57E"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M234.168 102.897H229.544C227.716 102.897 226.318 101.499 226.318 99.6711C226.318 97.8432 227.716 96.4453 229.544 96.4453H234.168C235.996 96.4453 237.394 97.8432 237.394 99.6711C237.394 101.499 235.996 102.897 234.168 102.897Z",
    fill: "#FCD57E"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M280.619 51.1762H274.168C272.34 51.1762 270.942 49.7784 270.942 47.9504C270.942 46.1225 272.34 44.7246 274.168 44.7246H280.619C282.447 44.7246 283.845 46.1225 283.845 47.9504C283.845 49.6708 282.447 51.1762 280.619 51.1762Z",
    fill: "#FCD57E"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M433.415 159.886H204.06V164.187H433.415V159.886Z",
    fill: "#726658"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "white",
    transform: "translate(208 -49)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomes);
export default __webpack_public_path__ + "static/media/homes.d201c7df95906a349890a36a1d6fce1d.svg";
export { ForwardRef as ReactComponent };